export default {
  watch: {
    'navigation.selectedSlide': {
      handler() {
        this.emitViewForComment()
      }
    }
  },
  methods: {
    getCommentsForSlide(comments, slide) {
      if (!comments) {
        return []
      }

      if (slide.type === "LearningObject" && this.mode === "edit") {
        return comments.filter(
          comment => !comment.deleted_at && comment.location && comment.location.slide_id.includes(slide.id)
        )
      }

      return comments.filter(
        comment => !comment.deleted_at && comment.location && comment.location.slide_id === slide.id
      )
    },
    emitViewForComment() {
      if (this.navigation.selectedSlide) {
        this.vm.$emit("update:view", {
          slide_id: this.navigation.selectedSlide.id
        })
      }
    },
    updateSelectedSlideFromComment() {
      if (!this.navigation.selectedSlide || this.view.slide_id != this.navigation.selectedSlide.id) {
        this.navigation.selectSlideById(this.view.slide_id);
      }
    }
  }
}
